/*
 * Personal Digital Spaces LLC ("COMPANY") CONFIDENTIAL
 * Unpublished Copyright (c) 2025 Personal Digital Spaces LLC, All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of COMPANY. The intellectual and technical concepts contained
 * herein are proprietary to COMPANY and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from COMPANY.  Access to the source code contained herein is hereby forbidden to anyone except current COMPANY employees, managers, contractors or partners who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of  COMPANY.   ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import React, { useState, useEffect } from 'react'
import { Checkbox, CheckboxGroup, Stack } from '@chakra-ui/react'
import {
  MdOutlineKeyboardArrowRight,
  MdOutlineKeyboardArrowDown
} from 'react-icons/md'
import Styles from './styles.module.sass'

const CheckboxesGrouped = ({
  customGroupNameComponent: CustomGroupNameComponent,
  defaultExpanded = true,
  defaultValue = [],
  expandable = true,
  groupName,
  onChange = null,
  options = []
}) => {
  const [selectedValues, setSelectedValues] = useState(defaultValue)
  const [isExpanded, setIsExpanded] = useState(defaultExpanded)
  const [checkedItems, setCheckedItems] = useState(
    options.map(option => defaultValue.includes(option.value))
  )
  const allChecked = checkedItems.every(Boolean)
  const isIndeterminate = checkedItems.some(Boolean) && !allChecked
  const toggleExpand = () => {
    setIsExpanded(!isExpanded)
  }
  const handleParentChange = (e) => {
    const isChecked = e.target.checked
    setCheckedItems(Array(options.length).fill(isChecked))

    if (isChecked) {
      const allValues = options.map(option => option.value)
      setSelectedValues(allValues)
    } else {
      setSelectedValues([])
    }
  }

  const handleCheckboxGroupChange = (values) => {
    setSelectedValues(values)

    const newCheckedItems = options.map(
      option => values.includes(option.value)
    )
    setCheckedItems(newCheckedItems)
  }

  useEffect(() => {
    if (onChange) {
      onChange(selectedValues)
    }
  }, [selectedValues])

  return (
    <>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <Checkbox
          isChecked={allChecked}
          isIndeterminate={isIndeterminate}
          onChange={handleParentChange}
        >
          { CustomGroupNameComponent
            ? <CustomGroupNameComponent />
            : groupName
          }
        </Checkbox>
        { expandable && (
          <button
            type="button"
            onClick={toggleExpand}
            className={Styles.expandButton}
          >
            {isExpanded
              ? <MdOutlineKeyboardArrowDown size="16" />
              : <MdOutlineKeyboardArrowRight size="16" />
            }
          </button>
        )}
      </div>

      {isExpanded && (
        <Stack pl={6} mt={1} spacing={1}>
          <CheckboxGroup
            value={selectedValues}
            onChange={handleCheckboxGroupChange}
          >
            {options.map(option => (
              <Checkbox
                key={option.value}
                value={option.value}
              >
                {option.label}
              </Checkbox>
            ))}
          </CheckboxGroup>
        </Stack>
      )}
    </>
  )
}

export default CheckboxesGrouped
